export default "__VITE_ASSET__Dd_Z8PgJ__"